/* eslint-disable */
import { createWebHistory, createRouter } from "vue-router";

import store from '@/store'

import HomePage from "@/views/HomePage"
import LoginPage from '@/views/user/LoginPage.vue'
import TemplateUser from '@/views/user/TemplatePage.vue'
import ProfilePage from '@/views/user/ProfilePage.vue'
import ContactPage from '@/views/ContactPage.vue'
import ErrorPage from '@/views/ErrorPage.vue'
import RechecherPage from '@/views/recherche/RechercherPage.vue'
import RechecherResultPage from '@/views/recherche/RechecherResultPage.vue'
import ConnexionPage from '@/views/user/ConnexionPage'
import ResetPassword from '@/views/user/ResetPassword'

const routes = [
  {
    path: "/user",
    component: TemplateUser,
    children: [
      {
        path: "login",
        name: 'login',
        component: LoginPage,
        beforeEnter: (to, from, next) => {
          if (store.getters.isAuthenticated === null)
            next()
          else
            next({ name: 'profile' })
        },
      },
      {
        path: 'connect',
        name: 'connect',
        component: ConnexionPage
      },
      {
        path: "profile",
        name: 'profile',
        component: ProfilePage,
        meta: {
          requiresAuth: true,
          privatePage: true
        }
      },
      {
        path: 'reset/:token?',
        name: 'reset',
        component: ResetPassword,
      },
    ]
  },
  {
    path: "/contact",
    name: "contactPage",
    component: ContactPage,
  },
  {
    path: "/search",
    name: "rechecherPage",
    component: RechecherPage,
    meta: {
      requiresAuth: true,
      privatePage: true
    }
  },
  {
    path: '/error/:code?/:callback?',
    name: 'error',
    component: ErrorPage,
    beforeEnter: (to, from, next) => {
      if (!to.params.code)
        next({ params: { code: '404' } })
      else
        next()
    }
  },
  {
    path: '/revues',
    redirect: '/'
  },
  {
    path: "/",
    name: 'home',
    component: HomePage,
    meta: {
      requiresAuth: true,
      privatePage: true
    }
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: { name: 'error', params: { code: '404' } }
  }
];

const router = createRouter({
  history: createWebHistory(),
  base: process.env.BASE_URL,
  routes,
});

export default {
  install(app) {
    router.install(app)

    router.beforeEach((to, from, next) => {
      const accessToken = app.$cookies.get('token')

      if (accessToken) {
        store.dispatch('setOnLoad', true)
        store.dispatch('setAuthFromApi', { 'token': accessToken }).then(() => {

          if (store.state.token4D == null) {
            // app.config.globalProperties.$api4d.getToken4d(accessToken).then((resp) => {
            //   store.dispatch('setToken4D', resp.data.data)
            // })
            next()
            store.dispatch('setOnLoad', false)
              .catch(error => console.log(error))
          } else {
            next()
            store.dispatch('setOnLoad', false)
          }
        })
          .catch(error => console.log(error))
      } else {
        // console.log('clientIP', store.state.clientIP)
        if (store.state.clientIP === null) {
          store.dispatch('setOnLoad', true)

          fetch('https://api.ipify.org?format=json').then(response => response.json()).then(response => {
            store.dispatch('setClientIP', response.ip)
            app.config.globalProperties.$api.postLoginByIP(response.ip).then(({ data }) => {
              if (data.code && data.code != '200') {
                if (to.meta.requiresAuth) {
                  next({ name: 'login' })
                  store.dispatch('setOnLoad', false)
                } else {
                  next()
                  store.dispatch('setOnLoad', false)
                }
              } else {
                store.dispatch('setAuthFromApi', { 'token': data.access_token }).then(() => {
                  app.$cookies.set('token', store.state.auth.token)
                  next()
                  store.dispatch('setOnLoad', false)
                })
              }

            })
              .catch(error => console.log(error))
          }).catch(error => {
            console.log(error)
            next();
            store.dispatch('setOnLoad', false)
          });
        } else {
          if (to.meta.requiresAuth) {
            next({ name: 'login' })
            store.dispatch('setOnLoad', false)
          } else {
            next()
            store.dispatch('setOnLoad', false)
            return
          }
        }
      }
    })
  }
};